import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './app/App';
import { Providers } from './app/providers';
import './styles/globals.css';
import { logger } from './lib/logger';
import './lib/i18n';

logger.info('Planning App starting', {
  version: __APP_VERSION__,
  env: __ENV__,
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <Providers>
      <App />
    </Providers>
  </StrictMode>
);

